/* eslint-disable react/jsx-indent, react/jsx-props-no-spreading */
import classNames from 'classnames';
import isArray from 'lodash/isArray';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

// import { useItemsPaginated } from '../../hooks/useItems';
import useItemsStore from '../../hooks/useItemsStore';

import { useApi } from '../../contexts/ApiContext';

import styles from '../../../styles/lists/query-list.module.scss';

const propTypes = {
    title: PropTypes.node,
    repository: PropTypes.string.isRequired,
    listComponent: PropTypes.elementType,
    listProps: PropTypes.objectOf(PropTypes.any), // eslint-disable-line react/forbid-prop-types
    query: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    count: PropTypes.number,
    initialPages: PropTypes.arrayOf(PropTypes.object), // eslint-disable-line react/forbid-prop-types
    onQueryChange: PropTypes.func,
    onQueryReset: PropTypes.func,
    onItemsCountChange: PropTypes.func,
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    isDark: PropTypes.bool,
    // clearOnEmpty: PropTypes.bool,
};

const defaultProps = {
    title: null,
    listComponent: null,
    listProps: null,
    query: {},
    count: null,
    initialPages: null,
    onQueryChange: null,
    onQueryReset: null,
    onItemsCountChange: null,
    className: null,
    itemClassName: null,
    isDark: false,
    // clearOnEmpty: false,
};

const QueryList = ({
    title,
    repository,
    listComponent: ListComponent,
    listProps,
    query,
    count: forcedCount,
    // initialPages,
    onQueryChange,
    onQueryReset,
    onItemsCountChange,
    className,
    isDark,
    // clearOnEmpty,
}) => {
    const api = useApi();

    const { page: queryPage = null, count: queryCount = null } = query || {};
    const getPage = useCallback(
        (page, count) =>
            api[repository]
                .get({
                    ...query,
                    page,
                    count,
                })
                .then((response) => {
                    const { pages = [] } = response || {};
                    const [currentPage = null] = pages || [];
                    return currentPage || null;
                }),
        [api, repository, query],
    );

    const {
        allItems: items,
        loading,
        pages,
    } = useItemsStore(repository, {
        getPage,
        query,
        onQueryChange,
        // pages: initialPages,
        page: queryPage,
        paginated: true,
        count: forcedCount || queryCount,
    });

    const finalItems = items || [];

    useEffect(() => {
        if (onItemsCountChange !== null && loading === false && pages !== null) {
            const total = isArray(pages)
                ? pages.reduce((sum, page) => sum + page.items.length, 0)
                : pages.total || 0;
            onItemsCountChange(total, repository);
        }
    }, [loading, onItemsCountChange, repository]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                {ListComponent !== null && finalItems.length > 0 ? (
                    <ListComponent
                        title={
                            title || (
                                <FormattedMessage defaultMessage="Title" description="List title" />
                            )
                        }
                        items={finalItems}
                        loading={loading}
                        onQueryChange={onQueryChange}
                        onQueryReset={onQueryReset}
                        isDark={isDark}
                        {...listProps}
                    />
                ) : null}
            </div>
        </div>
    );
};

QueryList.propTypes = propTypes;
QueryList.defaultProps = defaultProps;

export default QueryList;
